module.exports = __webpack_public_path__ + "img/dry-hairy-tree-03.4abec2c4.png";